const searchInput = document.getElementById('document-list-search')
const categorySelect = document.getElementById('document-list-category')
const folders = document.querySelectorAll('.document-list-folder')
const emptyMsg = document.querySelector('.document-list-empty')

function normalize(str) {
    return (str || '').toUpperCase()
}

function applyFilters() {
    const query = normalize(searchInput.value)
    const category = categorySelect ? categorySelect.value : ''
    let anyVisible = false

    folders.forEach((folder) => {
        const matchesCategory = !category || folder.dataset.category === category
        const items = folder.querySelectorAll('.document-list-item')
        let visibleCount = 0

        items.forEach((item) => {
            const matchesText = !query || normalize(item.textContent).indexOf(query) !== -1
            const show = matchesCategory && matchesText
            item.classList.toggle('hidden', !show)
            if (show) visibleCount++
        })

        const folderVisible = visibleCount > 0
        folder.classList.toggle('hidden', !folderVisible)

        if (folderVisible) anyVisible = true
    })

    if (emptyMsg) emptyMsg.classList.toggle('hidden', anyVisible)
}

if (searchInput && folders.length) {
    searchInput.addEventListener('input', applyFilters)
    if (categorySelect) {
        categorySelect.addEventListener('change', applyFilters)
    }
}
